/**
 * Core react app components and types
 *
 *  @module app
 **/
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { MainLayout } from './layouts/MainLayout'
import { LinksPage } from './pages/LinksPage'
import { ContactPage } from './pages/ContactPage'
import { NewsPage } from './pages/NewsPage'
import { EventsPage } from './pages/EventsPage'
import { TextEditorPage } from './pages/TextEditorPage'

// RosterPage is implemented but removed from navigation per booster decision (Feb 2026).
// import { RosterPage } from './pages/RosterPage'
// <Route path="/roster" element={<RosterPage />} />

function App() {
  return (
    <BrowserRouter>
      <MainLayout>
        <Routes>
          <Route path="/" element={<LinksPage />} />
          <Route path="/links" element={<LinksPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/calendar" element={<EventsPage />} />
          <Route path="/news" element={<NewsPage />} />
          <Route path="/text" element={<TextEditorPage />} />
        </Routes>
      </MainLayout>
    </BrowserRouter>
  )
}

export default App
